<template lang="pug">
  v-layout(align-start)
    v-flex
      v-app-bar(dark color='primary')
        v-toolbar-title.head-ajuste-precio ACTUALIZACIÓN DE PRECIOS
      v-card
        v-row(dense)
          v-col(cols='12')
            v-card(color='white')
              v-card-subtitle
                v-row(dense)
                  v-col(cols='12' xs='12' sm='6' md='6')
                    v-icon info
                    | Presione "PRECIO" para editar
                  v-col(cols='12' xs='12' sm='6' md='6')
                    v-row(dense justify='end')
                      v-btn(color='success', small, dark, @click='actualizarTaza') Actualizar Precio a tasa del dia
                    v-row(dense justify='end')
                      h5 Tasa del dia: 1$ - {{ tasa }} BsS
                v-divider
                v-row(dense)
                  v-col(cols='12' xs='12' sm='12' md='12')
                    h4 Incrementar Todos los Precios:
                  v-col(cols='12' xs='12' sm='6' md='6')
                    v-select(
                      outlined,
                      dense,
                      v-model="forma",
                      :items="arrayForma",
                      label="forma")
                  v-col(cols='12' xs='12' sm='6' md='6')
                    v-select(
                      v-model="seleccion"
                      :loading='loadingSeleccion'
                      :disabled="arraySeleccion.length === 0",
                      outlined,
                      dense,
                      :items="arraySeleccion",
                      label="Selecciones")
                  v-col(cols='12' xs='12' sm='6' md='6')
                    v-text-field(
                      type="number",
                      v-model.number="porcentaje",
                      outlined,
                      dense,
                      label="Porcentaje",
                      suffix="%")
                  v-col(cols='12' xs='12' sm='6' md='6')
                    v-btn(
                      color='success',
                      small,
                      dark,
                      @click="actualizarCategoria") Incrementar
              v-card-text
                v-data-table.elevation-1(:headers='headers' :search='search' item-key='productos' :items='productos' :items-per-page='page' :page.sync='sync' :loading='loading' loading-text='Cargando, por favor espere...')
                  template(v-slot:top)
                    v-toolbar(flat='' color='primary' dark='')
                      v-flex(class="d-flex flex-wrap justify-center")
                        v-toolbar-title Productos en Stock
                        v-divider.mx-4(inset='' vertical='')
                        v-spacer
                        v-text-field.text-xs-center(v-model='search' label='Búsqueda' single-line='' hide-details='' color='success')
                      v-dialog(v-model='dialog2' persistent scrollable max-width='40%')
                        v-card
                          v-card-title
                            span.headline Empaque
                          v-card-text
                            v-container
                              v-flex(xs12='xs12')
                                template
                                  v-simple-table(dense)
                                    template(v-slot:default)
                                      thead
                                        tr
                                          th(class="text-left") Presentación
                                          th(class="text-left") Cantidad
                                      tbody
                                        tr(v-for="item in empaquesArray")
                                          td {{ item.presentacion }}
                                          td {{ item.cantidad }}
                            v-btn(color='error' small='' dark='' @click='close')
                              v-icon mdi-close
                              | Cancelar
                  template(v-slot:item.idProducto.empaques='props')
                    v-icon(color='primary_2' @click='empaques(props.item.idProducto.empaques)') mdi-package-variant-closed
                  template(v-slot:item.moneda='props')
                    v-edit-dialog(:return-value.sync='props.item.moneda', large='', persistent='', @save='actualizarMoneda(props.item.idProducto._id, props.item.moneda)', @cancel='cancel', @open='open', @close='close')
                      v-chip(color='success' dark) {{ props.item.moneda }}
                      template(v-slot:input)
                        v-select(dense outlined v-model='props.item.moneda' :items='monedas' label='Moneda base')
                  template(v-slot:item.precioPro='props')
                    v-edit-dialog(:return-value.sync='props.item.precioPro', large='', persistent='', @save='save(props.item.precioPro, props.item.idProducto._id, props.item.idAlmacen._id, props.item.cantidad, props.item.monedaPro)', @cancel='cancel', @open='open', @close='close')
                      v-chip(color='success' dark) {{ props.item.precioPro }}  {{ props.item.monedaPro }}
                      template(v-slot:input)
                        v-text-field(v-model='props.item.precioPro', type="number", min="0", label='Editar2', single-line='' autofocus='')
                  template(v-slot:no-data)
                    h2.pa-2 No hay datos de productos asociados
                v-snackbar(v-model='snack', :timeout='3000', :color='snackColor')
                  | {{ snackText }}
                  v-btn(text='', @click='snack = false') Cerrar
</template>

<script>
import Api from '@/services/methods'
import { arrayMayusculas } from '../helpers/index'
export default {
  data: () => ({
    search: '',
    dialog: false,
    dialog2: false,
    snack: false,
    loading: true,
    snackColor: '',
    snackText: '',
    editedIndex: -1,
    page: 10,
    sync: 1,
    tasa: 0,
    forma: '',
    monedas: ['Bs', 'Dolar'],
    arrayForma: ['Todos', 'Fabricante', 'Marca', 'Linea', 'Portafolio'],
    seleccion: '',
    arraySeleccion: [],
    loadingSeleccion: false,
    pagination: {},
    empaquesArray: [],
    porcentaje: 0,
    headers: [
      {
        text: 'Codigo',
        sortable: false,
        value: 'idProducto.nombre'
      },
      { text: 'Nombre', value: 'idProducto.descripcion' },
      {
        text: 'Unidad de Medida',
        value: 'idProducto.unidadMedida.descripcion',
        sortable: false
      },
      {
        text: 'Empaques',
        value: 'idProducto.empaques',
        sortable: false,
        align: 'center'
      },
      //   { text: "Stock", value: "cantidad" },
      // { text: "IVA", value: "idIva.descripcion" },
      { text: 'Moneda', value: 'moneda' },
      { text: 'Precio', value: 'precioPro' }
      // { text: "Agregar", value: "action", sortable: false }
    ],
    productos: []
  }),

  watch: {
    forma (val) {
      let forma
      this.arraySeleccion = []

      switch (val) {
        case 'Todos':
          forma = null
          break
        case 'Fabricante':
          forma = 'fabricante'
          break
        case 'Marca':
          forma = 'marca'
          break
        case 'Linea':
          forma = 'linea'
          break
        case 'Portafolio':
          forma = 'portafolio'
          break
      }

      if (forma) {
        this.loadingSeleccion = true
        Api.get(`${forma}`)
          .then(res => {
            res.data.forEach(data => {
              this.arraySeleccion.push({
                value: data._id,
                text: data.nombre || data.descripcion
              })
            })
            this.loadingSeleccion = false
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al cargar'
                // text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    }
  },

  created () {
    this.initialize()
  },

  methods: {
    initialize () {
      this.listarProalma()
      // this.tasa = this.$store.state.config.tasa.tasaDia.valor
      Api.get('configuracion')
        .then(response => {
          this.tasa = response.data.tasa.tasaDia.valor
        })
    },

    formatoDecimal (i) {
      let n = parseFloat(i).toFixed(2)
      return Number(n).toLocaleString('es', { minimumFractionDigits: 2, maximumFractionDigits: 2 })
    },

    editItem (item) {
      this.editedIndex = this.productos.indexOf(item)
      this.editedItem = Object.assign({}, item)
      this.dialog = true
    },

    listarProalma () {
      Api.get('/proalma/stock/all')
        .then(response => {
          // console.log(response.data)
          this.productos = response.data
          this.productos.map(producto => {
            if (producto.moneda === 'Bs') {
              producto.precioPro = this.formatoDecimal(producto.precioBs)
              producto.monedaPro = 'Bs'
            } else if (producto.moneda === 'Dolar') {
              producto.precioPro = this.formatoDecimal(producto.precio)
              producto.monedaPro = '$'
            }
          })
          arrayMayusculas(this.productos, null)
          this.loading = false
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al cargar'
              // text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    empaques (empaque) {
      this.empaquesArray = empaque
      this.dialog2 = true
    },

    actualizar (moneda, precioPro) {
      let precioNuevo = {
        precioBs: 0,
        precio: 0
      }
      if (precioPro >= 0) {
        if (moneda === 'BS') {
          precioNuevo.precioBs = Number(precioPro)
          precioNuevo.precio = precioNuevo.precioBs / this.tasa
          precioNuevo.precio = precioNuevo.precio.toFixed(2)
          precioNuevo.precio = Number(precioNuevo.precio)
        } else if (moneda === '$') {
          precioNuevo.precio = Number(precioPro)
          precioNuevo.precioBs = precioNuevo.precio * this.tasa
          precioNuevo.precioBs = precioNuevo.precioBs.toFixed(2)
          precioNuevo.precioBs = Number(precioNuevo.precioBs)
        }
      }

      return precioNuevo
    },

    save (precioPro, id, almacen, cantidad, moneda) {
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })
      let precioNuevo = this.actualizar(moneda, precioPro)
      Api.put('/proalma/actualizarPrecios', {
        precioBs: precioNuevo.precioBs,
        precio: precioNuevo.precio,
        idProducto: id,
        idAlmacen: almacen,
        cantidad: cantidad
      })
        .then(response => {
          this.listarProalma()
          this.$swal({
            icon: 'success',
            title: 'Modificacion exitosa',
            text: 'Todos los cambios han sido efectuados'
          })
        })
        .catch(error => {
          if (error.response) {
            this.$swal({
              icon: 'error',
              title: 'Error al modificar',
              text: 'Por favor, verifique los datos e intente de nuevo'
            })
          } else if (error.request) {
            this.$swal({
              icon: 'error',
              title: 'Error de red',
              text: 'Por favor verique su conexion de internet'
            })
          } else {
            console.log('Error', error.message)
          }
        })
    },

    actualizarTaza () {
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })
      Api.put('/proalma/actualizarTasa')
        .then(response => {
          this.listarProalma()
          this.$swal({
            icon: 'success',
            title: 'Modificacion exitosa',
            text: 'Todos los cambios han sido efectuados'
          })
        })
        .catch(e => {
          this.$swal({
            icon: 'error',
            title: 'Error al modificar',
            text: 'Por favor, verifique los datos e intente de nuevo'
          })
        })
    },

    actualizarMoneda (idProducto, moneda) {
      this.$swal({
        title: 'Cargando...',
        html: 'Esperando respuesta del servidor',
        allowOutsideClick: false,
        onBeforeOpen: () => {
          this.$swal.showLoading()
        }
      })

      Api.put('/proalma/actualizarMoneda', {
        idProducto,
        moneda
      })
        .then(response => {
          this.listarProalma()
          this.$swal({
            icon: 'success',
            title: 'Modificacion exitosa',
            text: 'Todos los cambios han sido efectuados'
          })
        })
        .catch(e => {
          this.$swal({
            icon: 'error',
            title: 'Error al modificar',
            text: 'Por favor, verifique los datos e intente de nuevo'
          })
        })
    },

    actualizarCategoria () {
      if (this.forma !== '' && this.porcentaje > 0 && !isNaN(this.porcentaje)) {
        this.$swal({
          title: 'Cargando...',
          html: 'Esperando respuesta del servidor',
          allowOutsideClick: false,
          onBeforeOpen: () => {
            this.$swal.showLoading()
          }
        })

        Api.put('/proalma/actualizarCategoria', {
          categoria: this.forma.toLowerCase(),
          id: this.seleccion,
          porcentaje: this.porcentaje
        })
          .then(res => {
            this.listarProalma()
            if (res.data.message === 'ok') {
              this.$swal({
                icon: 'success',
                title: 'Modificacion exitosa',
                text: 'Todos los cambios han sido efectuados'
              })
              this.seleccion = ''
              this.porcentaje = 0
            } else {
              this.$swal({
                icon: 'info',
                text: res.data.message
              })
            }
          })
          .catch(error => {
            if (error.response) {
              this.$swal({
                icon: 'error',
                title: 'Error al modificar',
                text: 'Por favor, verifique los datos e intente de nuevo'
              })
            } else if (error.request) {
              this.$swal({
                icon: 'error',
                title: 'Error de red',
                text: 'Por favor verique su conexion de internet'
              })
            } else {
              console.log('Error', error.message)
            }
          })
      }
    },

    cancel () {
      this.snack = true
      this.snackColor = 'error'
      this.snackText = 'Cancelado'
    },
    open () {
      this.snack = true
      this.snackColor = 'primary'
      this.snackText = 'Editor abierto'
    },

    close () {
      this.dialog = false
      this.dialog2 = false
      setTimeout(() => {
        this.editedItem = Object.assign({}, this.defaultItem)
        this.editedIndex = -1
        this.cantidadNueva = 0
      }, 300)
    }
  }
}
</script>
<style lang="scss">
.head-ajuste-precio {
  font-size: 1.5rem;
}
@media screen and (max-width: 425px) {
  .head-ajuste-precio {
    font-size: 1rem;
  }
}
</style>
